<div class="content-pane">
  <h2>Session Timed Out</h2>
  <h4>You have been logged out.</h4>
  <p>You will need to login again to access all content.</p>
  <button routerLink="/login" matButton="filled">Log In</button>
</div>
